/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const MsTeams = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 512.000000 512.000000">
      <g fill="#000000" stroke="none" transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
        <path
          d="M2581 4529 c-163 -29 -335 -151 -424 -300 -60 -102 -82 -185 -81
-314 1 -104 11 -158 49 -247 7 -17 -34 -18 -771 -18 -734 0 -781 -1 -819 -19
-44 -20 -92 -70 -100 -104 -3 -12 -4 -445 -3 -963 l3 -941 27 -35 c57 -75 39
-73 641 -76 l537 -3 0 -23 c0 -39 40 -178 75 -259 121 -279 390 -518 679 -601
526 -153 1103 128 1291 629 15 39 28 71 29 73 2 1 20 -5 41 -13 125 -53 300
-69 425 -40 214 50 393 212 479 433 l26 67 3 598 3 599 -26 44 c-15 26 -43 54
-69 69 l-43 25 -996 0 -997 0 0 98 0 97 79 -9 c286 -34 581 175 656 463 21 81
21 231 0 313 -53 203 -228 381 -435 442 -69 21 -208 28 -279 15z m185 -270
c105 -19 201 -95 251 -199 23 -47 27 -68 28 -145 0 -78 -4 -97 -27 -145 -35
-71 -107 -143 -178 -178 -47 -23 -67 -27 -145 -27 -76 0 -99 4 -146 26 -79 37
-133 90 -171 167 -30 60 -33 75 -33 157 0 76 4 99 26 146 50 106 138 176 249
198 63 12 79 12 146 0z m-706 -1144 l0 -165 -200 0 -200 0 0 -535 0 -535 -165
0 -165 0 0 535 0 535 -200 0 -200 0 0 165 0 165 565 0 565 0 0 -165z m1430
-917 c0 -713 -1 -721 -59 -857 -97 -227 -294 -400 -530 -463 -102 -27 -284
-29 -396 -4 -258 58 -474 256 -567 518 -45 128 -68 116 230 120 l257 3 47 27
c32 19 52 41 67 71 21 42 21 55 21 640 l0 597 465 0 465 0 0 -652z m940 183
c0 -269 -4 -491 -10 -521 -33 -173 -161 -300 -332 -330 -107 -19 -218 9 -297
75 l-31 27 0 609 0 609 335 0 335 0 0 -469z"
        />
        <path
          d="M3958 4161 c-129 -41 -229 -129 -287 -250 -35 -74 -36 -79 -36 -197
0 -119 0 -121 37 -196 119 -241 392 -335 634 -218 61 30 152 116 191 181 61
102 79 235 47 354 -39 152 -169 284 -323 329 -72 21 -191 20 -263 -3z m238
-276 c116 -68 128 -243 24 -323 -98 -75 -252 -44 -307 62 -21 40 -22 141 -1
181 20 38 65 81 98 94 14 5 52 10 84 10 46 1 69 -5 102 -24z"
        />
      </g>
    </BaseSvgIcon>
  )
}

export default MsTeams
